import { render, staticRenderFns } from "./CreditInvestigation.vue?vue&type=template&id=65aecf7a&scoped=true"
import script from "./CreditInvestigation.vue?vue&type=script&lang=js"
export * from "./CreditInvestigation.vue?vue&type=script&lang=js"
import style0 from "./CreditInvestigation.vue?vue&type=style&index=0&id=65aecf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aecf7a",
  null
  
)

export default component.exports